/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Grid, Row, Col, FormControl, ControlLabel, Button, ButtonToolbar, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { linkListAction, linkchangestatusAction } from 'Admin/actions/link';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from 'react-loading';
import { clinicListAction, ClinicSimpleListAction } from 'Admin/actions/clinic';
import { specializationListAction } from 'Admin/actions/specialization';
import ClinicHeader from '../ClinicHeader/ClinicHeader';
import { appConstants } from 'Admin/_constants/app.constants.js';
import ReactPlayer from 'react-player';
import SecurityUrlComponent from '../../components/Common/SecurityUrlComponent';
import moment from 'moment';

var count = 1;

class LinkList extends Component {
    constructor(props) {
        super(props);

        let _id_clinic = '';
        // var type = 'admin';
        var type = 'all';
        if (this.props && this.props.location && this.props.location.state && this.props.location.state._id) {
            type = 'all';
            _id_clinic = this.props.location.state._id;
            localStorage.setItem('_id_clinic', this.props.location.state._id);
        }

        if (this.props && this.props.location && this.props.location.state && this.props.location.state.status) {
            type = 'all';
        }


        this.state = {
            clinicList: [],
            specializationList: [],
            linkList: [],
            isLoading: true,
            asc_desc: true,
            userRow: null,
            modelViewData: {},
            totalCount: 0,
            currentPage: 1,
            sizePerPage: 10,
            searchText: "",
            filter: true,
            _id_clinic: _id_clinic,
            formData: {
                clinicId: _id_clinic,
                specialization: "",
                direction: 'desc',
                order: "createdAt",
                offset: 0,
                limit: 10,
                type: type,

            },
            limitForm: {},
            //clinicView: this.props && this.props.location && this.props.location.state && this.props.location.state._id ? this.props.location.state._id : "",
            clinicView: _id_clinic,
            s3url: appConstants.s3UploadUrl,
        }

        this.onSerailNum = this.onSerailNum.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onUserCount = this.onUserCount.bind(this);

    }

    componentDidMount() {

        let formData = this.state.formData;
        if (this.props && this.props.location && this.props.location.state && this.props.location.state.status) {
            formData['type'] = 'all'
        }

        this.props.linkListAction('', this.state.formData);

        let data = this.state.limitForm;
        data['limitStatus'] = true;
        //this.props.clinicListAction(data);
        //this.props.specializationListAction(data);
        this.props.ClinicSimpleListAction();
    }

    componentWillReceiveProps(nextProps) {
        let listData = [];
        let i = 0;

        if (nextProps.isLinkList !== this.props.isLinkList) {
            this.setState({
                linkList: nextProps.LinkList.data.data,
                totalCount: nextProps.LinkList.data.count
            });
        }

        // if (nextProps.isClinicList !== this.props.isClinicList) {
        //     this.setState({ clinicList: nextProps.ClinicList.data.data });
        // }

        if (nextProps.isSpecializationList && nextProps.isSpecializationList !== this.props.isSpecializationList) {
            if (nextProps.SpecializationList && nextProps.SpecializationList.data && nextProps.SpecializationList.data.data && nextProps.SpecializationList.data.data.length > 0) {
                this.setState({
                    specializationList: nextProps.SpecializationList.data.data
                });

            }
        }

        if (this.state.isLoading == true) {
            this.setState({ isLoading: false });
        }

        if (nextProps.isClinicSimpleList !== this.props.isClinicSimpleList) {
            let list = nextProps.ClinicSimpleList.data;

            this.setState({
                clinicList: nextProps.ClinicSimpleList.data
            });

        }
    }

    onSerailNum(cell, row, enumObject, rowIndex) {
        return count++;
    }

    onUserCount(cell, row, enumObject, rowIndex) {

        return (this.state.currentPage - 1) * (this.state.sizePerPage) + (rowIndex + 1);
    }

    editButton(cell, row, enumObject, rowIndex) {
        if (this.props.location.state) {
            return (<span><Link to={{ pathname: `update-link/` + row._id, state: { row }, clinicDetail: this.props.location.state }} onClick={this.toggleEdit.bind(this, row)} ><i className="fa fa-pencil" aria-hidden="true"></i></Link>
                &nbsp;&nbsp; &nbsp;&nbsp;
                {/*<a href="javascript:void(0)" onClick={this.statusChangedHandler.bind(this, row)}><i className={(row.status === "active") ? ('fa fa-check') : ('fa fa-remove')} aria-hidden="true"></i></a>*/}

            </span>)
        } else {
            return (<span><Link to={{ pathname: `update-link/` + row._id, state: { row } }} onClick={this.toggleEdit.bind(this, row)} ><i className="fa fa-pencil" aria-hidden="true"></i></Link>
                &nbsp;&nbsp; &nbsp;&nbsp;
                {/*<a href="javascript:void(0)" onClick={this.statusChangedHandler.bind(this, row)}><i className={(row.status === "active") ? ('fa fa-check') : ('fa fa-remove')} aria-hidden="true"></i></a>*/}
            </span>)
        }
    }

    toggleEdit(event) {
        this.setState({
            userRow: event
        });
    }

    statusChangedHandler(event, elename) {
        let newstatus = {};
        if (event.status == 'active') {
            newstatus = 'inactive';
        } else {
            newstatus = 'active';
        }
        event['id'] = event._id;
        event['status'] = newstatus;
        this.props.linkchangestatusAction(event);
    }

    _setTableOption() {
        if (this.state.isLoading) {
            return (
                <Loading type='bars' color='#000000' style={{ margin: '0px auto', width: "40px" }} />
            );
        } else {
            return "No data found!";
        }
    }

    navigateto() {
        window.location.href = "Admin/add-link";
        this.clicked = "";
    }

    handleClinic(event) {

        let index = event.target.selectedIndex;
        let formData = this.state.formData;
        formData['clinicId'] = event.target.value
        formData['clinicName'] = event.target[index].text
        this.setState({ formData: formData });
    }

    handleSpecialization(event) {

        let index = event.target.selectedIndex;
        let formData = this.state.formData;
        formData['specialization_id'] = event.target.value
        formData['specialization_name'] = event.target[index].text
        this.setState({ formData: formData });

    }

    onSearch(e) {
        e.preventDefault();
        let formData = this.state.formData;
        //this.props.educatorListAction('',formData);
        this.props.linkListAction('', formData)
    }

    onPageChange(page, sizePerPage) {
        let data = {};
        data['type'] = this.state.formData.type;
        data['clinic_id'] = this.state.formData.clinicId;
        if (this.state.searchText === "") {
            data['direction'] = this.state.formData.direction;

            data['order'] = this.state.formData.order;
            data['offset'] = (page === -1) ? this.state.formData.offset : page - 1;
            data['limit'] = sizePerPage;
        } else {
            data['direction'] = this.state.formData.direction;
            data['order'] = this.state.formData.order;
            data['offset'] = (page === -1) ? this.state.formData.offset : page - 1;
            data['limit'] = sizePerPage;
        }
        data['status'] = this.state.formData.status;

        this.setState({ sizePerPage: sizePerPage })
        this.setState({ currentPage: page })
        this.props.linkListAction(data)
        
        if(this.state.sizePerPage !== sizePerPage || this.state.totalCount < page * sizePerPage)  {
            eval('$(".ps").scrollTop(0)');
          }
    }

    onSearchChange(text) {
        if (text !== "") {
            if (text.length >= 1) {
                let data = {}
                data['direction'] = this.state.formData.direction;
                data['order'] = this.state.formData.order;
                data['offset'] = this.state.formData.offset;
                data['limit'] = this.state.formData.limit;
                data['type'] = this.state.formData.type;
                data['search'] = text;
                data['status'] = this.state.formData.status;
                this.setState({ sizePerPage: 10 })
                this.setState({ currentPage: 1 })
                this.props.linkListAction(data);
            }
        } else {
            setTimeout(() => {      
                this.componentDidMount();
            }, 100);
        }
        this.setState({ searchText: text });
    }

    clearSearch(e) {
        this.setState({ searchText: '' });
        this.componentDidMount();
    }
    

    sortHandle(){
        this.setState({ asc_desc:!this.state.asc_desc });
        let data = this.state.formData;
        data.direction = this.state.asc_desc? "asc":"desc"
        this.setState({ formData : data });
        this.props.linkListAction(data);
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    addLink(e) {
        this.props.history.push({
            pathname: '/admin/add-link',
            state: {
                clinic_id: this.props && this.props.location && this.props.location.state && this.props.location.state._id ? this.props.location.state._id : "",
                clinicName: this.props && this.props.location && this.props.location.state && this.props.location.state.name ? this.props.location.state.name : "",
                clinicDetail: this.props.location.state,
            }
        })
    }

    allView() {
        var data = this.state.formData;
        data['type'] = "all";
        this.setState({ formData: data, filter: true });
        this.props.linkListAction('', this.state.formData);
    }

    adminView() {
        var data = this.state.formData;
        data['type'] = "admin";
        this.setState({ formData: data, filter: false });
        this.props.linkListAction('', this.state.formData);
    }

    editLink(cell, row, enumObject, rowIndex) {
        if (row.image) {
            return (<span>
                <a href="javascript:void(0)" onClick={this.openLinkModel.bind(this, row)}><i className="fa fa-eye" aria-hidden="true"></i></a>
            </span>)
        }
    }

    openLinkModel(row) {

        let arr = row.image.split('.');
        let output = arr.pop();
        if (output == "mp4") {
            row.type = "video";
        } else if (output == "pdf") {
            row.type = "pdf";

        } else {
            row.type = "image";
        }

        this.setState({ modelViewData: row, linkModel: true });
    }

    render() {

        const { modelViewData } = this.state;
        const selectRowProp = { mode: 'checkbox' };
        const options = {
            onSortChange: this.onSortChange,
            clearSearch: true,
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPage: this.state.sizePerPage,
            onPageChange: this.onPageChange,
            page: this.state.currentPage,
            // onSearchChange: this.onSearchChange,
            noDataText: this._setTableOption(),
        };

        const getDrugCreationDate = (cell, row, enumObject, rowIndex) => {
            return <span>{moment(row.createdAt).format("DD-MMM-YYYY")}</span>;
        };

        return (
            <div className="main-content" style={{ padding: '15px 0px' }}>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            {this.state.clinicView &&
                                <ClinicHeader componentData={{ clinicId: this.state.clinicView }} />
                            }
                            <Card
                                content={
                                    <div className="fresh-datatables">
                                        <Row>
                                            <Col md={6}>
                                                <ButtonToolbar>
                                                    <Button className="inacti-button" fill pullRight onClick={(e) => { this.addLink(e) }} >Add My Clinic</Button>
                                                    {!this.state.clinicView &&
                                                        <ButtonToolbar>
                                                            <Button className={this.state.formData.type == 'admin' ? 'acti-button' : "inacti-button"} fill onClick={(e) => { this.adminView(e) }} >Added By Admin</Button>
                                                            <Button className={this.state.formData.type == 'all' ? 'acti-button' : "inacti-button"} fill onClick={(e) => { this.allView(e) }} >View All</Button>
                                                        </ButtonToolbar>
                                                    }
                                                </ButtonToolbar>
                                            </Col>
                                            <Col md={6}>
                                                {this.state.filter && this.state._id_clinic == '' &&
                                                    <div>
                                                        <Row>
                                                            <Col md={8}>
                                                                {/* <Col componentClass={ControlLabel}>
                                                            Clinic
                                            </Col> */}
                                                                <FormControl componentClass="select" name="clinicName" value={this.state.formData.clinicId} onChange={e => { this.handleClinic(e); }}>
                                                                    <option value="">Select Clinic</option>
                                                                    {this.state.clinicList.map(function (item) {
                                                                        return <option key={item._id} value={item._id}>{item.name}({item.clinicId})</option>
                                                                    })}
                                                                </FormControl>
                                                            </Col>


                                                            <Col md={2}>
                                                                <Button bsStyle="info searchBtn2" onClick={e => { this.onSearch(e); }} >Search</Button>
                                                            </Col>
                                                        </Row>&nbsp;
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                        <div className="table-resposive educator-L">
                                        <div className='search-box-admin'>
                                            <div className='search'>
                                                <input type="text" name="search" className="form-control" onChange={e => { this.onSearchChange(e.target.value.trimStart().replace(/\s+/g, " ")); }} value={this.state.searchText} placeholder="Search" />
                                                <span className='input-group-btn'>
                                                <Button onClick={(e) => { this.clearSearch(e) }}>Clear</Button> 
                                                </span>
                                            </div>
                                        </div>
                                            <BootstrapTable
                                                selectRow="{selectRowProp}"
                                                deleteRow={false}
                                                data={this.state.linkList}
                                                multiColumnSearch={true}
                                                pagination={true}
                                                options={options}
                                                striped
                                                hover
                                                condensed
                                                scrollTop={'Bottom'}
                                                remote={true}
                                                fetchInfo={{ dataTotalSize: this.state.totalCount }}
                                            >
                                                <TableHeaderColumn hidden={true} tdAttr={{ 'data-attr': '_id' }} dataField='invitationId' isKey searchable={false}>Id</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '6%',textAlign: 'center' }} tdStyle={{ width: '6%',textAlign: 'center' }} tdAttr={{ 'data-attr': '#' }} dataField='' dataFormat={this.onUserCount}>#</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '15%', textAlign: 'center' }} tdStyle={{ width: '15%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Clinic Id' }} dataField='clinicNumber'>Clinic Id
                                                {
                                                    this.state.asc_desc?
                                                    <i onClick={(e) => {this.sortHandle()}} style={{cursor : 'pointer'}} class="fa fa-caret-up" aria-hidden="true"></i>:
                                                    <i onClick={(e) => {this.sortHandle()}} style={{cursor : 'pointer'}} class="fa fa-caret-down" aria-hidden="true"></i>
                                                }
                                                </TableHeaderColumn>
                                                <TableHeaderColumn tdAttr={{ "data-attr": "title" }} thStyle={{ width: "15%", textAlign: "center" }} tdStyle={{ width: "15%", textAlign: "center" }} dataField="createdAt" dataFormat={getDrugCreationDate}> Date</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '25%', textAlign: 'center' }} tdStyle={{ width: '25%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'doctorName' }} dataField='doctorName'>Doctor Name</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Clinic Name' }} dataField='clinicName'>Clinic Name</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '20%', textAlign: 'center' }} tdStyle={{ width: '20%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Title' }} dataField='title'>Title</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '15%', textAlign: 'center' }} tdStyle={{ width: '15%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Link' }} dataField='link'>Link</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '25%', textAlign: 'center' }} tdStyle={{ width: '25%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Description' }} dataField='description'>Description</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '12%', textAlign: 'center' }} tdStyle={{ width: '12%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Status' }} dataField='status'>Status</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '10%', textAlign: 'center' }} tdStyle={{ width: '10%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Action' }} dataFormat={this.editLink.bind(this)}>View</TableHeaderColumn>
                                                <TableHeaderColumn thStyle={{ width: '10%', textAlign: 'center' }} tdStyle={{ width: '10%', textAlign: 'center' }} tdAttr={{ 'data-attr': 'Action' }} dataFormat={this.editButton.bind(this)} >Action</TableHeaderColumn>
                                            </BootstrapTable>
                                        </div>
                                    </div>
                                }
                            />
                        </Col>
                        <Col>
                            <Modal show={this.state.linkModel} onHide={() => this.setState({ linkModel: false })} dialogClassName="modal-md">
                                <Modal.Header>
                                    <Row>
                                        <Col md={12}>
                                            <Row>
                                                <Col md={12}>
                                                    <Modal.Title><h5>{modelViewData.title}</h5></Modal.Title>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Modal.Header>
                                <Modal.Body className="Knowledge-Share card img-ccent">
                                    <Row>
                                        <Col md={12}>
                                            <div>

                                                <div>
                                                    <Row>
                                                        <Col md={12}>
                                                            {modelViewData && modelViewData.type && modelViewData.type == "image" &&
                                                                <SecurityUrlComponent
                                                                    className="activeImage admin-active-image"
                                                                    data={modelViewData.image}
                                                                    type="img"
                                                                    width="70%"
                                                                    height="100%"
                                                                />

                                                                //<img src={this.state.s3url + modelViewData.image} width="70%" height="100%" />
                                                            }
                                                            {modelViewData && modelViewData.type && modelViewData.type == "video" &&
                                                                <SecurityUrlComponent
                                                                    className="react-player"
                                                                    data={modelViewData.image}
                                                                    type="video"
                                                                    width="100%"
                                                                    height="100%"
                                                                    playing controls="true"
                                                                    volume="1"

                                                                />

                                                                //<ReactPlayer className='react-player' width='100%' height='100%' url={this.state.s3url + modelViewData.image} playing controls="true" volume="1" />
                                                            }
                                                            {modelViewData && modelViewData.type && modelViewData.type == "pdf" &&
                                                                <SecurityUrlComponent
                                                                    className="activeImage"
                                                                    data={modelViewData.image}
                                                                    target="_blank"
                                                                    type="anchor"
                                                                />
                                                                //  <a href={this.state.s3url + modelViewData.image} target="_blank"> Download pdf</a>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type="button" onClick={() => this.setState({ linkModel: false })} className="btn-fill btn-wd btn btn-secondary">Close</button>&nbsp;
                                </Modal.Footer>
                            </Modal>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        LinkList: state.link.LinkList,
        isLinkList: state.link.isLinkList,
        isLinkListError: state.link.isLinkListError,
        LinkChangeStatus: state.link.LinkChangeStatus,
        isLinkChangeStatus: state.link.isLinkChangeStatus,
        isLinkChangeStatusError: state.link.isLinkChangeStatusError,

        ClinicList: state.clinic.ClinicList,
        isClinicList: state.clinic.isClinicList,
        isClinicListError: state.clinic.isClinicListError,

        SpecializationList: state.specilization.SpecializationList,
        isSpecializationList: state.specilization.isSpecializationList,
        isSpecializationListError: state.specilization.isSpecializationListError,

        ClinicSimpleList: state.clinic.ClinicSimpleList,
        isClinicSimpleList: state.clinic.isClinicSimpleList,
        isClinicSimpleListError: state.clinic.isClinicSimpleListError
    }
}
export default withRouter(connect(mapStateToProps, { linkListAction, linkchangestatusAction, clinicListAction, specializationListAction, ClinicSimpleListAction })(LinkList));
